var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "uploadList" }, [
    _c(
      "ul",
      { staticClass: "list-group" },
      [
        _vm._l(_vm.value, function (file, index) {
          return _c(
            "li",
            { staticClass: "list-group-item" },
            [
              _vm._v("\n            " + _vm._s(file.name) + "\n            "),
              _c("fa", {
                staticClass: "pull-right",
                attrs: { icon: "xmark" },
                on: {
                  click: function ($event) {
                    return _vm.removeUpload(index)
                  },
                },
              }),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.value.length < this.maxFiles
          ? _c(
              "li",
              {
                staticClass: "list-group-item btn",
                on: { click: _vm.showFileDialog },
              },
              [
                _c("input", {
                  attrs: { type: "file", multiple: "" },
                  on: {
                    change: function ($event) {
                      return _vm.fileSelected($event)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Add File "),
      _c("i", { staticClass: "fa fa-paperclip" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }